module.exports = __webpack_public_path__ + "img/bg1.2e38a8c2.png";